import { render, staticRenderFns } from "./DashboardMain.html?vue&type=template&id=6ed0f7aa&scoped=true&external"
import script from "./DashboardMain.ts?vue&type=script&lang=ts&external"
export * from "./DashboardMain.ts?vue&type=script&lang=ts&external"
import style0 from "./DashboardMain.css?vue&type=style&index=0&id=6ed0f7aa&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed0f7aa",
  null
  
)

export default component.exports